import Link from 'next/link'
import { Fragment } from 'react'
import { RxSlash } from 'react-icons/rx'

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@/components/atoms/ui/breadcrumb'

import { cn } from '@/lib/utils'

interface ItemsProps {
  url?: string
  label: string
}

interface BreadcrumbProps {
  items: ItemsProps[]
  className?: string
  isGTM?: boolean
}

export const BreadcrumbCustom = ({ items, className, isGTM }: BreadcrumbProps) => {
  return (
    <Breadcrumb className={cn(className, 'overflow-x-auto scrollbar-hidden')}>
      <BreadcrumbList className="font-medium text-black min-w-[370px]">
        {items.map((item, index) => (
          <Fragment key={index}>
            <BreadcrumbItem>
              {item.url ? (
                <Link
                  href={item.url}
                  className={cn(
                    index == 2 && 'truncate max-w-24 sm:max-w-40 lg:max-w-2xl md:max-w-48',
                    isGTM && 'gtm-article-tag'
                  )}
                >
                  {item.label}
                </Link>
              ) : (
                <BreadcrumbPage
                  className={cn(
                    'text-gray-500 truncate sm:max-w-40 lg:max-w-2xl md:max-w-48',
                    items.length > 3 && 'max-w-11'
                  )}
                >
                  {item.label}
                </BreadcrumbPage>
              )}
            </BreadcrumbItem>
            {index !== items.length - 1 && (
              <BreadcrumbSeparator>
                <RxSlash />
              </BreadcrumbSeparator>
            )}
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
